module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-10-66d538d45a60b24b42a60e5c9ef2c34f.jpg";